import React, { useContext } from 'react';
import Modal from 'styled-react-modal';
import ModalVinculação from './ModalVinculação/ModalVinculação';
import { ModalContext } from '../../contexts/ModalContext';

const StyledModal = Modal.styled`
	z-index: 30000;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  opacity: ${(props) => props.opacity};
  transition : all 0.3s ease-in-out;`;

const ModalComponent = () => {
	const { isOpen, opacity, toggleModal, afterOpen, beforeClose } =
		useContext(ModalContext);
	return (
		<StyledModal
			allowScroll={false}
			isOpen={isOpen}
			afterOpen={afterOpen}
			beforeClose={beforeClose}
			onBackgroundClick={toggleModal}
			onEscapeKeydown={toggleModal}
			opacity={opacity}
			backgroundProps={{ opacity }}>
			<ModalVinculação />
		</StyledModal>
	);
};

export default ModalComponent;
